import { useContext } from 'react';
import LoginInputContext from './LoginInputContext';

const useLoginInput = () => {
    const context = useContext(LoginInputContext);
    if (context === null) {
        throw new Error('useLoginInput must be used within a LoginInputProvider');
    }
    return context;
};

export default useLoginInput;
